export default __webpack_public_path__ + "static/media/KebabMenu.79681e1f.svg";